<template>
   <el-container style="height:100%; border: 1px solid #eee">
      <el-aside width="20%" style="background-color: rgb(238, 241, 246);border-right:2px solid #eee">
         <slot name="aside"></slot>   
      </el-aside>
      <el-container>
        <slot name="main"></slot>
      </el-container>
   </el-container> 
</template>

<script>
import ComponentContainer from './BoxContainer.vue'
export default {
    components:{
        ComponentContainer
    }    
}
</script>